















import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import { Product } from '@/models/Product';


@Component({})
export default class ImageView extends Vue {

	@Prop()
	images?: string[];
	selectedIndex = 0;

	get items(): string[] {
		return this.images;
	}

	zoomClick(): void {
		this['$zoom'](this.images[this.selectedIndex]);
	}
}
